import React from 'react';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

export default ({
  classes,
  // mwDashboard,
  // sylectusMessage,
  mwRedirectEmail,
  autogeneratedMWEmail,
}) => {

  return (
    <div>
      <div className={classes.descriptionFont}>
        <li className={classes.alignCenter}>1. On your computer, open&nbsp;
          <div>
            <a href="https://sylectus.com/" target="_blank" rel="noopener noreferrer"
              className={`${classes.providersText} ${classes.pointer}`}
            ><span className={classes.pointer}>Sylectus</span><OpenInNewRoundedIcon className={classes.iconInfo}/></a>
          </div>&nbsp; and log in to the account you want to forward messages from.
        </li>
        <li>2. At the the left menu select "Users" and click "User profiles".</li>
        <div style={{ margin: '10px 0' }}>
          <img
            title='sylectus menu'
            alt='sylectus menu'
            width='100%'
            height='auto'
            border='none'
            src="/images/sylectus_menu.jpg">
          </img>
        </div>
        <li>3. Click the "Add New User" button.</li>
        <div style={{ margin: '10px 0' }}>
          <img
            title='sylectus create user btn'
            alt='sylectus create user btn'
            width='100%'
            height='auto'
            border='none'
            src="/images/sylectus_create_user_btn.jpg">
          </img>
        </div>
        <li>4. Fill out all required fields. Paste&nbsp;{mwRedirectEmail ? mwRedirectEmail : autogeneratedMWEmail()}&nbsp;to E-Mail fileld.</li>
        <li>At "E-MAIL NOTIFICATIONS" section select "Yes" for both options.</li>
        <li>Click "Create user" button.</li>
        <div style={{ margin: '10px 0' }}>
          <img
            title='sylectus create user'
            alt='sylectus create user'
            width='100%'
            height='auto'
            border='none'
            src="/images/sylectus_create_user.jpg">
          </img>
        </div>
        <li className={classes.alignCenter}>5. Now you must sign in with this newly created user account to Sylectus.
        This step will authorize Milkyweb to receive loads from Sylectus.</li>
        {/* <li className={classes.alignCenter}> To do that, go to the&nbsp;{mwDashboard()}&nbsp;and follow the instruction <span >in&nbsp;{sylectusMessage()}.</span> </li> */}
        <li>From here, the messages sending from Sylectus to your Milkyweb account should start soon.</li>
      </div>

      <div className={`${classes.p20} ${classes.m20}`} style={{ border: '1px dashed #DBD9E7', backgroundColor: '#F1F1F6' }}>
        <span>
        ⚠️ Your Sylectus data is safe because an administrator password is required to log into your Sylectus account, besides the sign-on information provided in the Sylectus email you'll see on the Milkyweb dashboard. 
        </span>
      </div>
    </div>
  );
};
